// extracted by mini-css-extract-plugin
module.exports = {"title":"defaultLayout_title__19Lnk","content":"defaultLayout_content__GdabT","menuWrapper":"defaultLayout_menuWrapper__1TqaK","logo":"defaultLayout_logo__19d6U"};